import {
  IDashoardOperationalManagement,
  IOperationalManagement,
} from "../../types/operational-management";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;
export type ApiFilterOptions = {
  status?: string[];
  situation?: string;
  treatment?: string;
  search?: string;
  page?: number;
  itemsPerPage?: number;
  orderBy?: string;
  fields?: string;
};
const makeRequestDebounced = createDebounce(makeRequest, 200);
export const getOperationalManagement = async (
  options: ApiFilterOptions = {}
) => {
  const {
    status = [],
    situation = "",
    treatment = "",
    search = "",
    page = 1,
    itemsPerPage = 100,
    orderBy = "-days",
    fields = "companyId, licensePlate, status, days, situation, notes, daysAtBase, lastLogTimestamp, vehicleId, vehicleLongitude, vehicleLatitude",
  } = options;
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  if (statusParam) params.append("filters[status]", statusParam);
  const situationParam = (situation ?? "").trim();
  if (situationParam) params.append("filters[situation]", situationParam);
  const treatmentParam = (treatment ?? "").trim();
  if (treatmentParam) params.append("filters[treatment]", treatmentParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/operationalmanagement?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IOperationalManagement[]
  > & {
    lastUpdated: Date;
    totalItems: number;
    dashboard: IDashoardOperationalManagement;
  };
  return {
    ok: result.ok,
    data: result.data,
    dashboard: result.dashboard,
    totalItems: result.totalItems,
    lastUpdated: result.lastUpdated,
    message: result.message,
  };
};

export async function addNotesOperationalManagement(
  id: string,
  noteData: { content: string; expectedResolutionDate: Date; status: string }
) {
  const url = `${API_URL}/operationalmanagement/notes`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ _id: id, ...noteData }),
  };
  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IOperationalManagement>
  >;
}
